import React from 'react';
import './SourceCard.css';

const TYPE_CONFIG = {
  news_article: { border: '#7132f5', icon: '📰', label: 'News' },
  tweet: { border: '#1DA1F2', icon: '𝕏', label: 'Tweet' },
  polymarket: { border: '#149e61', icon: '📊', label: 'Prediction' },
  fred_series: { border: '#686b82', icon: '📈', label: 'FRED' },
  job_signal: { border: '#9497a9', icon: '💼', label: 'Jobs' },
  bdc_signal: { border: '#d92d20', icon: '🏦', label: 'BDC' },
  analyst_note: { border: '#7132f5', icon: '🎯', label: 'Analyst' },
  market_price: { border: '#149e61', icon: '💵', label: 'Price' },
};

function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export default function SourceCard({ source, index, highlighted, compact, dimmed }) {
  const config = TYPE_CONFIG[source.source_type] || TYPE_CONFIG.news_article;

  const Tag = source.url ? 'a' : 'div';
  const linkProps = source.url ? { href: source.url, target: '_blank', rel: 'noopener noreferrer' } : {};

  return (
    <Tag
      {...linkProps}
      className={`source-card ${highlighted ? 'source-card--highlighted' : ''} ${compact ? 'source-card--compact' : ''} ${dimmed ? 'source-card--dimmed' : ''}`}
      style={{ borderLeftColor: dimmed ? 'rgba(255,255,255,0.05)' : 'rgba(255,255,255,0.2)' }}
      id={`source-${source.id}`}
    >
      <div className="source-card__header">
        <span className="source-card__type">{config.icon} {config.label}</span>
        {index != null && <span className="source-card__index">[{index + 1}]</span>}
      </div>
      <div className="source-card__title">{source.title}</div>
      <div className="source-card__meta">
        <span className="source-card__source">{source.source_name}</span>
        {source.retrieved_at && (
          <span className="source-card__date">{formatDate(source.retrieved_at)}</span>
        )}
        {source.metadata?.published_at && (
          <span className="source-card__date">{formatDate(source.metadata.published_at)}</span>
        )}
      </div>

      {source.source_type === 'tweet' && (
        <div className="source-card__tweet-meta">
          {source.metadata?.likes != null && <span>♥ {source.metadata.likes}</span>}
          {source.metadata?.retweets != null && <span>🔁 {source.metadata.retweets}</span>}
        </div>
      )}

      {source.source_type === 'polymarket' && source.metadata && (
        <div className="source-card__poly">
          <div className="source-card__poly-bar">
            <div
              className="source-card__poly-fill"
              style={{ width: `${(source.metadata.market_price || 0) * 100}%` }}
            />
          </div>
          <span className="source-card__poly-price">
            {((source.metadata.market_price || 0) * 100).toFixed(0)}%
          </span>
          {source.metadata.ev > 0 && (
            <span className="source-card__poly-edge">
              +{((source.metadata.ev || 0) * 100).toFixed(0)}% edge
            </span>
          )}
        </div>
      )}

      {source.source_type === 'fred_series' && source.quote && (
        <div className="source-card__fred-value">{source.quote}</div>
      )}

      {source.source_type === 'job_signal' && source.quote && (
        <div className="source-card__job-detail">{source.quote}</div>
      )}

      {source.quote && source.source_type === 'news_article' && (
        <div className="source-card__quote">{source.quote.slice(0, 120)}</div>
      )}
    </Tag>
  );
}
